import { useRef, useState } from 'react';

import ImageGallery from 'react-image-gallery';
import ImageCarousel from './ImageCarousel/ImageCarousel';
import ImageUploadButton from './ImageUploadButton/ImageUploadButton';

import styles from './ImageField.module.css';
import useAppSelector from 'hooks/useAppSelector';
import { Progress } from 'semantic-ui-react';

function ImageField() {
  const { images } = useAppSelector((state) => state.auctionForm);
  const [uploadingProgress, setUploadingProgress] = useState(100);

  const [showFullScreen, setShowFullScreen] = useState(false);
  const fullScreenRef = useRef<ImageGallery>(null);

  const openImageGallery = (index: number) => {
    fullScreenRef.current?.fullScreen();
    fullScreenRef.current?.slideToIndex(index);
    setShowFullScreen(true);
  };

  return (
    <>
      <div className={styles['flex-container']}>
        <ImageUploadButton setUploadingProgress={setUploadingProgress} />
        <ImageCarousel openImageGallery={openImageGallery} />
        <div className={showFullScreen ? '' : styles.hidden}>
          <ImageGallery
            ref={fullScreenRef}
            items={images.map(({ url }) => ({ original: url }))}
            showThumbnails={false}
            showPlayButton={false}
            useBrowserFullscreen={false}
            showBullets
            onScreenChange={setShowFullScreen}
          />
        </div>
      </div>
      {uploadingProgress !== 100 && (
        <Progress className={styles.progress} percent={uploadingProgress} indicating size="tiny" />
      )}
    </>
  );
}

export default ImageField;
